import { render, staticRenderFns } from "./categoriesSubcategories-v2.vue?vue&type=template&id=76a6550f&lang=html"
import script from "./categoriesSubcategories-v2.vue?vue&type=script&lang=js"
export * from "./categoriesSubcategories-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports